export default "__VITE_ASSET__BFioAqdy__"